if (document.body.hasAttribute('data-disable-pace')) {
    paceOptions = {
        ajax: false,
        startOnPageLoad: false
    };
}
